const Constants = {

  applicationName: 'RansomStop',

  customerName: 'devqa',
  apiHost: 'devqa-api',
  domainName: 'ransomstop.net',
  version: '25.5.6',
  userPoolId: 'us-east-1_m0QL9bx8Y',
  userPoolClientId: '5nmiafiv0mhm4r07p58ujodpop',
  authDomain: 'devqa-ransomstop-net.auth.us-east-1.amazoncognito.com',
  region: 'us-east-1',
  invokeUrl: '',

}
export default Constants